<template>
    <div>
      <b-pagination v-if="totalRows>perPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="my-pag"
        @change="currentPageChanged"
        v-model="currentPage"
        limit=10
        />
    </div>
</template>

<style>
.nav-pills:not(.nav-pills-icons) > li > a {
  border-radius: 0.2rem !important;
}

.nav-pills .nav-link:not(.active) {
  color: #343a40 !important;
  text-align: left;
  font-size: 1em;
}

.nav-pills .nav-link.active {
  background-color: #6cc5c4 !important;
  color: white !important;
  text-align: left;
  font-size: 1.2em;
}

.page-item.active .page-link {
  background-color: #87909A !important;
  border-color: #87909A !important;
}
.page-link,
.page-link:hover {
  color: #87909A;
}
</style>

<script>
export default {
  props: ['totalRows', 'perPage'],
  data () {
    return {
      currentPage: 1
    }
  },
  methods: {
    setCurrentPage (numPage) {
      this.currentPage = numPage
    },
    currentPageChanged (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/TableManagerBottom.vue